import { emptyJwtPayload, JwtPayloadType } from '@/types/jwtTypes';
import { jwtDecode } from 'jwt-decode';

/**
 * Decodes a JWT token and returns the payload
 * @param token - The JWT token string
 * @returns JwtPayloadType - The decoded payload or empty payload if invalid
 */
export const getDecodedToken = (token: string): JwtPayloadType => {
    if (!token) {
        return { ...emptyJwtPayload };
    }

    try {
        const decoded = jwtDecode<Omit<JwtPayloadType, 'token'>>(token);

        return {
            ...decoded,
            token,
        };
    } catch {
        return { ...emptyJwtPayload };
    }
};
